import { svgUploadCtrl } from './svg.upload.controller';
import template from './svg.upload.html';

export const svgUpload: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: svgUploadCtrl,
  controllerAs: 'vm',
  template,
  restrict: 'AE',
  scope: {
    houseId: '=',
  },
});
